<style lang="scss" scoped>
.toggle-container {
    display: flex;
    flex-wrap: wrap;
    flex-flow: row;
    margin-top: 10px;
    .toggle {
        color: var(--border-color);
        border-color: var(--border-color);
        border: 1px solid;
        transition: border-color 0.2s, color 0.2s;
        height: 56px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
        cursor: pointer;
        width: 50%;
        user-select: none;
        flex-flow: column;
        text-align: center;
        &.on {
            border-radius: 2px 0 0 2px;
        }
        &.off {
            border-radius: 0 2px 2px 0;
        }
        &.active {
            border-color: var(--primary-dark);
            color: var(--primary-dark);
            font-weight: 600;
        }
    }
}
</style>

<template>
    <div class="form-group">
        <div class="toggle-container" :class="{'mt-0' : !hasLabel}">
            <div class="toggle on" :class="{ active: localValue}" @click="handleInput(true)">{{ $t('general.yes') }}</div>
            <div class="toggle off" :class="{ active: !localValue}" @click="handleInput(false)">{{ $t('general.no_short') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * Boolean defining the value
         * @type Boolean
         */
        value: {
            type: Boolean,
            required: true,
        },
        
        /**
         * Boolean that defines if we have label
         * @type {Boolean}
         */
        hasLabel: {
            type: Boolean,
            default: true
        },
    },
    data: () => ({
        localValue: true
    }),
    mounted() {
        this.localValue = this.value
    },
    methods: {
        handleInput(value) {
            this.localValue = value
            this.$emit('input', this.localValue)
        }
    },
    watch: {
        value: function() {
            this.localValue = this.value
        }
    }
}
</script>
